import { useEffect, useId } from 'react';

function addStyle(id: string, css: string) {
  const style = document.createElement('style');
  style.id = id;
  style.textContent = css;
  document.head.append(style);
}

export const useBodyLock = (locked = false) => {
  const uniqueId = useId();
  useEffect(() => {
    if (!locked) {
      return undefined;
    }
    addStyle(
      uniqueId,
      `body {
        overflow: hidden;
      }`
    );
    return () => {
      document.getElementById(uniqueId)?.remove();
    };
  }, [locked, uniqueId]);
};
